{
  "validation.maxAttachments": "Dozwolone są maksymalnie {{max}} załączniki.",
  "validation.minAttachments": "Potrzebujesz co najmniej {{min}} załączników.",
  "validation.maxAttachmentSize": "Załączniki nie mogą przekraczać {{max}} megabajtów.",
  "validation.attachmentListItemRequired": "Proszę dołączyć załącznik do \"{{category}}\".",
  "validation.attachmentListItemMaxAttachments": "Możesz dodać maksymalnie {{max}} załączników dla kategorii \"{{category}}\".",
  "validation.attachmentListItemMaxAttachmentSize": "Załączniki w kategorii {{category}} nie mogą przekraczać {{max}} megabajtów.",
  "attachment.bsoCategory.DiagnosticReport": "Raport diagnostyczny",
  "attachment.bsoCategory.InvoiceDocument": "Faktura",
  "attachment.bsoCategory.ShippingDocument": "Dokument wysyłkowy",
  "attachment.bsoCategory.Letter": "List",
  "attachment.bsoCategory.PictureReference": "Zdjęcie poglądowe",
  "attachment.bsoCategory.BugReport": "Zgłoszenie błędu",
  "attachment.bsoCategory.Other": "Inne",
  "attachment.bsoCategory.Unclassified": "Niesklasyfikowane",
  "attachment.bsoCategory.ServiceForms": "Formularz serwisowy",
  "attachment.bsoCategory.RegistrationDocument": "Dokument rejestracyjny",
  "attachment.bsoCategory.ShopInside": "Zdjęcie wnętrza sklepu",
  "attachment.bsoCategory.ShopImageMigration": "Przeniesienie zdjęcia sklepu",
  "attachment.bsoCategory.ShopImage": "Zdjęcie witryny sklepowej",
  "attachment.uploadButton": "Prześlij {{category}}",
  "attachment.uploadDropdown": "Dodaj plik"
}